import React from "react";
import T from "prop-types";

import Widget from "2g-widget";

import { useProvozniInformacePosledni } from "b2b/api/hooks";
import ProvozniInformaceCards from "b2b/components/provozni-informace-cards";

import useMessages from "./i18n/useMessages";
import CardRedirect from "./CardRedirect";

function ProvozniInformacePosledniWidget({ pocet }) {
  const messages = useMessages();
  const provozniInformace = useProvozniInformacePosledni(pocet);
  return (
    <Widget
      title={messages.widgetLabel()}
      collapsable={false}
      className="b2b-ProvozniInformacePosledniWidget"
    >
      <ProvozniInformaceCards
        loading={provozniInformace.loading}
        items={provozniInformace.data}
        onDeleteSuccess={provozniInformace.reload}
        addOn={<CardRedirect />}
      />
    </Widget>
  );
}

ProvozniInformacePosledniWidget.propTypes = {
  pocet: T.number
};

export default React.memo(ProvozniInformacePosledniWidget);
